var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgShowOn = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "m6.205 15.738-1.466 1.485 1.068 1.054 1.764-1.788L8.7 15.346l.492-.499 1.053-1.067 3.512-3.56 1.054-1.067.492-.499 1.127-1.143 1.439-1.457L16.8 5l-1.9 1.925A10.09 10.09 0 0 0 12 6.5c-5 0-8.333 3.667-10 5.5.908.998 2.31 2.54 4.205 3.738m1.081-1.096 1.041-1.055a4 4 0 0 1 5.21-5.28l.14-.142A8.566 8.566 0 0 0 12 8c-3.559 0-6.183 2.184-7.948 4 .867.893 1.943 1.874 3.234 2.642m5.051-5.12a2.5 2.5 0 0 0-2.81 2.848zM12 17.5c-1.039 0-2.005-.158-2.9-.425l1.224-1.24A8.57 8.57 0 0 0 12 16c3.559 0 6.183-2.184 7.948-4-.867-.893-1.942-1.874-3.234-2.642l1.081-1.095C19.691 9.46 21.092 11.002 22 12c-1.667 1.833-5 5.5-10 5.5m4-5.5a4 4 0 0 1-5.537 3.694l1.2-1.217a2.5 2.5 0 0 0 2.81-2.848l1.2-1.216c.21.487.327 1.023.327 1.587",
    clipRule: "evenodd"
  })));
};
export default SvgShowOn;